import { Grid } from '@radix-ui/themes';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DocumentTitle } from '~/components/DocumentTitle';
import { Account } from '~/features/account/Account';
import { Header } from '~/features/account/Header';
import { accountContentSchema } from '~/types/searchParams';

const searchparamsSchema = z.object({
  backToProjectId: z.string().optional(),
  content: accountContentSchema.optional(),
  flow: z.string().optional(),
  org: z.string().optional(),
  // Set by the SSO guard redirect. Account toasts once, then removes it.
  ssoRequired: z.boolean().optional(),
});

export const Route = createFileRoute('/_auth/account')({
  component: RouteComponent,
  validateSearch: searchparamsSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps }) => {
    return {
      backToProjectId: deps.search?.backToProjectId,
    };
  },
});

function RouteComponent() {
  return (
    <>
      <DocumentTitle title={`Account - Versori`} />
      <Grid
        height="100svh"
        width="100%"
        style={{
          display: 'grid',
          gridTemplateAreas: `
          "header"
          "interface"
        `,
          gridTemplateRows: '5.5rem 1fr',
        }}
      >
        <Header />

        <Account />
      </Grid>
    </>
  );
}
